import React from 'react';
import FAQAccordion from './FAQAccordion';
interface FAQSectionProps {
  items: Array<{
    question: string;
    answer: string;
  }>;
  title?: string;
  description?: string;
}

/**
 * Component to render FAQ sections with an accordion
 */
const BlogFAQSection: React.FC<FAQSectionProps> = ({
  items,
  title = "Häufige Fragen",
  description
}) => {
  if (!items || items.length === 0) return null;
  
  return (
    <div className="blog-faq-section mt-16 pt-8 border-t border-joerg-200">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-joerg-800 mb-4">
            {title}
          </h2>
          {description && (
            <p className="text-joerg-600 leading-relaxed max-w-2xl mx-auto">
              {description}
            </p>
          )}
        </div>
        
        <FAQAccordion items={items} />
      </div>
    </div>
  );
};
export default BlogFAQSection;